import * as React from 'react';

import QuizResult, { IQuzAnswer } from './QuizResult';

interface IProps {
    results: IQuzAnswer[];
}

function QuizResults({ results }: IProps): JSX.Element {
    return <>{results.map(result => <QuizResult key={result.id} result={result} />)}</>;
}

export default React.memo(QuizResults);
